import React, { useEffect } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import MainRoute from "./config/route";
import axios from "axios";
import { fetchIpAddress, getOrCreateDeviceId } from "./helpers/commonHelpers";

// axios.defaults.headers = {
//   ip: await fetchIpAddress(),
// };

const App = () => {
  useEffect(() => {
    // Set device ID and IP header once on app load
    const setupHeaders = async () => {
      const deviceId = getOrCreateDeviceId(); // Create or get from localStorage
      axios.defaults.headers.common["x-device-id"] = deviceId;

      try {
        const ip = await fetchIpAddress();
        axios.defaults.headers.common["ip"] = ip;
      } catch (error) {
        console.error("Failed to fetch IP address:", error);
      }
    };

    setupHeaders();
  }, []);
  const currentPath = window.location.pathname;

  if (currentPath === "/") {
    /// Add the class to <body> if the path is "/"
    document.body.classList.add("landing-page");
  } else {
    // Remove the class when not on the "/" path
    document.body.classList.remove("landing-page");
  }

  return (
    <div>
      <MainRoute />
    </div>
  );
};

export default App;
